import { NumberWithSuffixInput } from "components/inputs/NumberWithSuffixInput";
import React from "react";
import {
	BooleanInput,
	ReferenceInput,
	SelectInput,
	TextInput,
	maxLength,
	usePermissions,
} from "react-admin";
import { useForm, useFormState } from "react-final-form";

import { FormGroupGrid, GridForm, GridInput } from "../../../components/GridForm";
import { DateInput, TimeInput } from "../../../components/inputs";
import { OSFCUserSelectInput } from "../../../components/inputs/OSFCUserSelect";
import TerminalDatesInput from "../../../components/inputs/TerminalDatesInput";
import { YesNoInput } from "../../../components/inputs/YesNoInput";
import { UserRole } from "../../../entities";
import { TaskService, TaskServicesMobileFlow } from "../../../entities/TaskService";
import { TaskStatus } from "../../../entities/TaskStatus";
import { required } from "../../../utils/validation/required";
import { ServiceInput, serviceChoices, unlockedServiceChoices } from "./inputs/ServiceInput";

const TaskForm = ({ isEditForm = false, ...props }) => {
	const { permissions } = usePermissions();
	const form = useForm();

	const handle_eta_change = (event) => {
		if (event) {
			const eventDate = new Date(event);
			const year = eventDate.getFullYear();
			const month = String(eventDate.getMonth() + 1).padStart(2, "0");
			const day = String(eventDate.getDate()).padStart(2, "0");
			const formattedDate = `${year}-${month}-${day}`;
			form.change("etd_date", formattedDate);
		}
	};

	const handle_etd_change = (event) => {
		if (event) {
			const eventDate = new Date(event);
			const year = eventDate.getFullYear();
			const month = String(eventDate.getMonth() + 1).padStart(2, "0");
			const day = String(eventDate.getDate()).padStart(2, "0");
			const formattedDate = `${year}-${month}-${day}`;
			form.change("eta_date", formattedDate);
		}
	};

	const isDisabledForOSFCEmployee =
		isEditForm && permissions && permissions.role === UserRole.osfc_employee;

	const isCompletedTaskForOSFCEmployee =
		isDisabledForOSFCEmployee && props.record?.status === TaskStatus.COMPLETED;

	const isServiceLocked = isEditForm && TaskServicesMobileFlow.includes(props.record?.service);

	return (
		<GridForm {...props}>
			<FormGroupGrid>
				<GridInput
					sm={6}
					md={3}
					lg={3}
					component={TextInput}
					source="title"
					validate={[required()]}
					disabled={isDisabledForOSFCEmployee}
				/>

				<GridInput
					source="service"
					sm={2}
					component={ServiceInput}
					choices={isEditForm && !isServiceLocked ? unlockedServiceChoices : serviceChoices}
					validate={[required()]}
					defaultValue={TaskService.other}
					disabled={isDisabledForOSFCEmployee || isServiceLocked}
				/>
				{isEditForm && (
					<GridInput
						sm={6}
						md={2}
						source="status"
						reference="task-statuses"
						disabled={isCompletedTaskForOSFCEmployee}
					>
						<ReferenceInput validate={[required()]}>
							<SelectInput optionText="name" />
						</ReferenceInput>
					</GridInput>
				)}
				<GridInput sm={6} md={2} validate={[required()]} disabled={isDisabledForOSFCEmployee}>
					<ReferenceInput source="terminal_id" reference="terminal" validate={[required()]}>
						<SelectInput optionText="name" />
					</ReferenceInput>
				</GridInput>
				<GridInput
					xs={12}
					sm={1}
					component={BooleanInput}
					source="priority"
					disabled={isDisabledForOSFCEmployee}
				/>
			</FormGroupGrid>

			<FormGroupGrid xs={12} style={{ marginBottom: 20 }}>
				{/* <GridInput 
                    xs={6} sm={6} md={3} 
                    component={NumberInput} 
                    source="rank" 
                    defaultValue={0} 
                    disabled={isDisabledForOSFCEmployee}
                /> */}
			</FormGroupGrid>

			<FormGroupGrid xs={12} style={{ marginBottom: 20 }}>
				<GridInput xs={6} sm={6} md={3} disabled={isCompletedTaskForOSFCEmployee}>
					<TerminalDatesInput
						component={DateInput}
						source="eta_date"
						onChange={handle_eta_change}
					/>
				</GridInput>

				<GridInput xs={6} sm={6} md={3} disabled={isCompletedTaskForOSFCEmployee}>
					<TerminalDatesInput component={TimeInput} source="eta_time" />
				</GridInput>

				<GridInput xs={6} sm={6} md={3} disabled={isCompletedTaskForOSFCEmployee}>
					<TerminalDatesInput
						component={DateInput}
						source="etd_date"
						onChange={handle_etd_change}
					/>
				</GridInput>

				<GridInput xs={6} sm={6} md={3} disabled={isCompletedTaskForOSFCEmployee}>
					<TerminalDatesInput component={TimeInput} source="etd_time" />
				</GridInput>
			</FormGroupGrid>

			<FormGroupGrid xs={12}>
				<GridInput
					source="assignee_1"
					sm={6}
					md={6}
					lg={6}
					component={OSFCUserSelectInput}
					disabled={isDisabledForOSFCEmployee}
				/>

				<GridInput
					source="assignee_2"
					sm={6}
					md={6}
					lg={6}
					component={OSFCUserSelectInput}
					disabled={isDisabledForOSFCEmployee}
				/>

				<GridInput
					sm={12}
					md={6}
					component={TextInput}
					source="description"
					multiline
					rows={6}
					validate={[maxLength(1024)]}
					disabled={isDisabledForOSFCEmployee}
				/>

				<GridInput
					sm={12}
					md={6}
					component={TextInput}
					source="notes"
					multiline
					rows={6}
					validate={[maxLength(1024)]}
					disabled={isCompletedTaskForOSFCEmployee}
				/>
			</FormGroupGrid>
		</GridForm>
	);
};

export default TaskForm;
